import {
  APP_ENV,
  APP_ENVS,
  FARO_APP_NAME,
  FARO_URL,
  VERCEL_GIT_COMMIT_SHA,
} from '@/constants/env'

let initialized = false

export const initializeFaroClient = async () => {
  if (initialized) return

  const shouldInitialize =
    globalThis.window !== undefined &&
    FARO_URL &&
    FARO_APP_NAME &&
    APP_ENV === APP_ENVS.PRODUCTION

  if (!shouldInitialize) return
  initialized = true

  const [{ getWebInstrumentations, initializeFaro }, { TracingInstrumentation }] =
    await Promise.all([
      import('@grafana/faro-web-sdk'),
      import('@grafana/faro-web-tracing'),
    ])

  initializeFaro({
    url: FARO_URL,
    app: {
      name: FARO_APP_NAME,
      environment: APP_ENVS.PRODUCTION,
      version: VERCEL_GIT_COMMIT_SHA?.slice(0, 7) ?? '1.0.0',
    },
    instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()],
  })
}
